import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchSPK = createAsyncThunk(
  "track-order-status/spk",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/spk`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching spk data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch spk data"
      );
    }
  }
);

export const createSPK = createAsyncThunk(
  'track-order-status/spk/store', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.post(`${API_URL}/track-order-status/spk/store`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
          
          return response.data;
      } catch (error) {
          console.error('Error store spk:', error);
          return rejectWithValue(error.response?.data || 'Failed to store items');
      }
  }
);

export const detailSPK = createAsyncThunk(
  "track-order-status/spk/detail",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/spk/detail/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("Error detail spk data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to detail spk data"
      );
    }
  }
);

export const fetchSalesOrder = createAsyncThunk(
  "track-order-status/sales-order",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/sales-order`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching spk data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch spk data"
      );
    }
  }
);

export const detailSalesOrder = createAsyncThunk(
  "track-order-status/sales-order/detail",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/sales-order/detail/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data;
    } catch (error) {
      console.error("Error detail sales order data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to detail sales order data"
      );
    }
  }
);

export const fetchPayment = createAsyncThunk(
  "track-order-status/payment",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/payment/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching payment data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch payment data"
      );
    }
  }
);

export const createPayment = createAsyncThunk(
  "track-order-status/payment/store",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/track-order-status/payment/store`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data;
    } catch (error) {
      console.error("Error store payment data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store payment data"
      );
    }
  }
);

export const updatePayment = createAsyncThunk(
  "track-order-status/payment/update",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.put(`${API_URL}/track-order-status/payment/update/${items.payment_id}`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data;
    } catch (error) {
      console.error("Error store payment data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store payment data"
      );
    }
  }
);

export const getDelivery = createAsyncThunk(
  "track-order-status/delivery",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/delivery/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data;
    } catch (error) {
      console.error("Error get delivery data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to get delivery data"
      );
    }
  }
);

export const getPDFU = createAsyncThunk(
  "track-order-status/pdfu",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/pdfu/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data;
    } catch (error) {
      console.error("Error get pdfu data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to get pdfu data"
      );
    }
  }
);

export const createDelivery = createAsyncThunk(
  "track-order-status/delivery/store-update",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/track-order-status/delivery/store-update`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data;
    } catch (error) {
      console.error("Error store delivery data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store delivery data"
      );
    }
  }
);

export const getDocumentHandover = createAsyncThunk(
  "track-order-status/document-handover",
  async (item, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/track-order-status/document-handover/${item}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data;
    } catch (error) {
      console.error("Error get document handover data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to get document handover data"
      );
    }
  }
);

export const createDocumentHandover = createAsyncThunk(
  "track-order-status/document-handover/store-update",
  async (items, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.post(`${API_URL}/track-order-status/document-handover/store-update`, items, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data;
    } catch (error) {
      console.error("Error store document handover data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to store document handover data"
      );
    }
  }
);

// Redux slice
const trackOrderStatusSlice = createSlice({
  name: "trackOrderStatus",
  initialState: {
    spk: [],
    detail_spk: [],
    sales_order: [],
    detail_sales_order: [],
    payment: [],
    delivery: [],
    pdfu: [],
    document_handover: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSPK.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSPK.fulfilled, (state, action) => {
        state.isLoading = false;
        state.spk = action.payload;
      })
      .addCase(fetchSPK.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSalesOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSalesOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.sales_order = action.payload;
      })
      .addCase(fetchSalesOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createSPK.fulfilled, (state, action) => {
          state.spk.push(action.payload.data);
      })
      .addCase(detailSPK.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(detailSPK.fulfilled, (state, action) => {
        state.isLoading = false;
        state.detail_spk = action.payload;
      })
      .addCase(detailSPK.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(detailSalesOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(detailSalesOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.detail_sales_order = action.payload;
      })
      .addCase(detailSalesOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchPayment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.payment = action.payload;
      })
      .addCase(fetchPayment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createPayment.fulfilled, (state, action) => {
          state.payment.push(action.payload.data);
      })
      .addCase(updatePayment.fulfilled, (state, action) => {
        const index = state.payment.findIndex((item) => item.payment_id === action.payload.data.payment_id);
        
        if (index !== -1) {
            state.payment[index] = { ...state.payment[index], ...action.payload.data };
        }
        state.isLoading = false;
      })
      .addCase(getDelivery.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDelivery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.delivery = action.payload;
      })
      .addCase(getDelivery.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createDelivery.fulfilled, (state, action) => {
        state.delivery = action.payload.data;
      })
      .addCase(getPDFU.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPDFU.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pdfu = action.payload;
      })
      .addCase(getPDFU.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getDocumentHandover.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDocumentHandover.fulfilled, (state, action) => {
        state.isLoading = false;
        state.document_handover = action.payload;
      })
      .addCase(getDocumentHandover.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createDocumentHandover.fulfilled, (state, action) => {
        state.document_handover = action.payload.data;
      });
    },
});

export default trackOrderStatusSlice.reducer;